export default {
  utility: {
    status:(data)=>{
       if (data.status===404) {
           return "En recolección"
       } else {
        if (data.type === "dhl") {
            let messge = data.shipment_event[data.shipment_event.length-1].status
            if (messge === "Envio entregado al destinatario") {
                return "Envío entrgado"
            } else if(messge === "El envío fue recolectado."){
                return "Envío Recolectado"
            }else{
                return "Envío en tránsito"
            }
        }
        else if (data.type === "dhlApi") {
            if(data.shipment_event == null || data.shipment_event == undefined)
            {
                 return "En recolección"
            }
            let messge = data.shipment_event[data.shipment_event.length-1].status
            if (messge === "Envio entregado al destinatario") {
                return "Envío entrgado"
            } else if(messge === "El envío fue recolectado."){
                return "Envío Recolectado"
            }else{
                return "Envío en tránsito"
            }
        }
        else if (data.type === "ampm") {
              if(data.shipment_event.length > 0)
              {
                  let messge = data.shipment_event[data.shipment_event.length-1].status

                  return messge

              }
              else
              {
                return "Envío en tránsito"
              }
         }
         else if (data.type === "Estafeta") {
               if(data.shipment_event.length > 0)
               {
                   let messge = data.shipment_event[data.shipment_event.length-1].status

                   return messge

               }
               else
               {
                 return "Guía creada"
               }
          }
         else{

        }
       }
    },
    statusFedex:(response)=>{
        if (response.status === "IN") {
            return response.description
        }else if(response.status === "DL"){
            return response.description
        }else{
            return "En recolecion"
        }
    }
  }

}



// WEBPACK FOOTER //
// ./src/commons/utility.js